import {flow} from 'lodash-es';

export const applyTo = (target) => (...fns) => flow(fns)(target);

export const applier = (lodashFn) => (...args) => (target) => lodashFn(target, ...args);
